__turbopack_context__.v({
  "reward-link": "member-rewards-module-scss-module__BnFOga__reward-link",
});
